import { UserSettings } from '../models/user/UserSettings'

export default {
  props: {
    settings: UserSettings,
    fineTuningSettings: Object,
    isFineTuning: Boolean
  },
  computed: {
    defaults () {
      return this.settings.defaults !== undefined ? this.settings.defaults : {}
    }
  },
  methods: {
    getPlaceholder (field) {
      if (this.defaults !== undefined) {
        return field in this.defaults ? this.defaults[field].toString() : null
      } else {
        return ''
      }
    }
  },
}
